<template>
	<div id="title">
		<img 
			src="../assets/img/AgeIcon.png" 
			alt="age_calculator_logo" 
			height="80"
		>
		<span>
			&nbsp; &nbsp; AGE CALCULATOR
		</span>
	</div>
</template>

<script>

export default {

}
</script>

<style scoped>
	#title {
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgb(255, 217, 0);
		
		box-sizing: border-box;
		padding: 20px;
		border-bottom: 5px solid orange;
	}

	#title span {
		font-size: 32px;
		font-family: 'Anton', sans-serif;
	}
</style>